import api from "./api";

export const getLegalEntity = async (id) => {
    const res = await api.get(`/legalentity/${id}`);
    return res.data;
};

export const createLegalEntity = async (payload) => {
    const res = await api.post("/legalentity", payload);
    return res.data;
};

export const updateLegalEntity = async (payload) => {
    const res = await api.put(`/legalentity/${payload.id}`, payload);
    return res.data;
};

export const deleteLegalEntity = async (id) => {
    const res = await api.delete(`/legalentity/${id}`);
    return res.data;
};

export const getLegalEntityDeliveryPrice = async (id) => {
    const res = await api.get(`/legalentity/${id}/delivery-price`);
    return res.data;
};